import React, { useState } from "react";
import { Collapse, Navbar, Nav, NavItem, NavLink, NavbarText, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, } from "reactstrap";
import { useNavigate } from "react-router-dom";
import "./NavbarComponent.css";
import { FiMenu } from "react-icons/fi";
import { BiUser } from "react-icons/bi";
// import { AiOutlineBell } from "react-icons/ai"
// import Bell from "./Bell";
// import Swal from "sweetalert2";
// import { BiExit } from "react-icons/bi";

export function NavbarBorrowSystem() {
  const user = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();

  const [openNavbar, setOpenNavbar] = useState(false);
  const toggle = () => {
    setOpenNavbar(!openNavbar);
  };

  // function IsLogout() {

  // }
  async function waitLogout() {
    let res = await fetch("/api/Auth/logout", {
      method: "POST",
      headers: { 'token': user.token },
    })
    const resJson = await res.json();
    localStorage.removeItem(user);
    localStorage.clear();
    if (!resJson.authStatus) {
      navigate("/")
    }
  }

  return (
    <>
      <header className="">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="d-flex align-items-center flex-wrap justify-content-center">
            <img className="img-icon" alt="logo" src={"../../images/logoDSD2.png"} />
            <div className="d-flex flex-column text-white">
              <h3>ระบบสารสนเทศกองทุนพัฒนาฝีมือแรงงาน</h3>
              <h5>กรมพัฒนาฝีมือแรงงาน</h5>
            </div>
          </div>
          <Nav className="me-3 d-flex justify-content-center">
            <NavbarText
              className="d-flex align-items-center justify-content-center"
            >
              <span className="text-white" style={{ fontWeight: "bold", fontSize: "1rem" }}>{user.fullName}</span>

            </NavbarText>
            <UncontrolledDropdown nav inNavbar className="me-5">
              <DropdownToggle nav caret>
                <BiUser id="user-icon" />
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  className="menu-item-link"
                  hidden={user.roldId === "4" || user.roldId === "3"}
                  onClick={() => {
                    navigate("/profile");
                  }}>
                  ข้อมูลส่วนตัว
                </DropdownItem>
                <DropdownItem
                  className="menu-item-link"
                  onClick={() => {
                    navigate("/profile/changePassword");
                  }}
                  hidden={user.roldId === "4" || user.roldId === "3"}
                >
                  เปลี่ยนรหัสผ่าน
                </DropdownItem>
                <DropdownItem
                  hidden={user.roldId === "4" || user.roldId === "3"}
                  divider
                />
                <DropdownItem
                  className="menu-item-link"
                  onClick={() => { waitLogout() }}>
                  ออกจากระบบ
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </div>
      </header>
      <Navbar expand="xl" className="style-navbar">

        <FiMenu onClick={toggle} className="btn-toggle" />
        <Collapse isOpen={openNavbar} navbar>
          <Nav
            className="me-auto d-flex align-items-center justify-content-center mx-3"
            navbar
          >
            <NavItem>
              <NavLink href="/menu" className="menu-item-link">
                หน้าแรก
              </NavLink>
            </NavItem>

            <NavItem hidden={user.roldId !== "4" && user.roldId !== "3"}>
              <NavLink href="/borrowing/result-borrowing" className="menu-item-link">
                คําขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
              </NavLink>
            </NavItem>

            <NavItem hidden={user.roldId !== "4"}>
              <NavLink href="/borrowing/proposal" className="menu-item-link">
                แบบเสนอคณะอนุกรรมการ
              </NavLink>
            </NavItem>
            <NavItem hidden={user.roldId !== "4"}>
              <NavLink href="/borrowing/contact/changeinterest" className="menu-item-link">
                กำหนดอัตราดอกเบี้ย
              </NavLink>
            </NavItem>
            <NavItem hidden={user.roldId !== "4"}>
              <NavLink href="/borrowing/contact/yearbudgetform" className="menu-item-link">
                บันทึกข้อมูลงบประมาณวงเงิน
              </NavLink>
            </NavItem>
            <NavItem hidden={user.roldId !== "4"}>
              <NavLink
                href="/borrowing/reports"
                className="menu-item-link"
              >
                รายงาน
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar >

    </>
  );
}
